import { useMemo } from 'react'

import { useAppSelector } from 'src/v2/store/hooks'

import { useGetUsersQuery } from '../api/user.api'
import { selectCurrentOrganization } from '../selectors/user.selectors'
import { UserType, UsersResponseModel } from '../user.types'

interface IUseGetUsersNoPaginationUseCase {
  users: UsersResponseModel['records']
  usersQueryStatus: {
    isLoading: boolean
    isSuccess: boolean
    isFetching: boolean
  }
  assignees: { label: string; value: string }[]
}

const useGetUsersNoPaginationUseCase = (): IUseGetUsersNoPaginationUseCase => {
  const { id: organizationId } = useAppSelector(selectCurrentOrganization)

  const { isLoading, isSuccess, data, isFetching } = useGetUsersQuery({
    organizationId,
    userType: UserType['REGULAR'],
  })

  const users = useMemo(() => {
    return data?.records ?? []
  }, [data])

  return {
    users,
    usersQueryStatus: {
      isLoading,
      isSuccess,
      isFetching,
    },
    assignees: users.map((user) => ({ label: user.name, value: user.id })),
  }
}

export default useGetUsersNoPaginationUseCase
